export default {
  'menu.overview': 'Overview',
  'menu.fund': 'Funds',
  'menu.fund.list': 'Fund List',
  'menu.fund.formation': 'New Fund Approval',
  'menu.fund.formationDetail': 'Formation Detail',
  'menu.fund.detail': 'Fund Detail',
  'menu.fundraising': 'Fundraising Follow-up',
  'menu.fundraising.board': 'Board',
  'menu.fundraising.opportunities': 'Investor Opportunities',
  'menu.fundraising.opportunityDetail': 'Opportunity Detail',
  'menu.lpAndContact': 'Investors & Contacts',
  'menu.lpAndContact.lp': 'Investor Orgs',
  'menu.lpAndContact.contact': 'Contacts',
  'menu.lpAndContact.lpDetail': 'Investor Detail',
  'menu.lpAndContact.contactDetail': 'Contact Detail',
  'menu.contribution': 'Capital Calls & Receipts',
  'menu.contributionDetail': 'Contribution Detail',
  'menu.setting': 'Settings',
  'menu.setting.dictionary': 'Dictionary',
  'menu.setting.permissions': 'Permissions',
  'menu.setting.modelSettings': 'Model Settings',
  'menu.login': 'Login',
  'menu.account': 'Account',
  'menu.account.center': 'Profile',
  'menu.account.workbench': 'Workbench',
  'menu.account.tenantManagement': 'Tenants',
  'menu.account.logout': 'Logout',
};
